import { render, staticRenderFns } from "./StandardizedPhoneInput.vue?vue&type=template&id=3bd62ad8&scoped=true"
import script from "./StandardizedPhoneInput.vue?vue&type=script&lang=ts"
export * from "./StandardizedPhoneInput.vue?vue&type=script&lang=ts"
import style0 from "./StandardizedPhoneInput.vue?vue&type=style&index=0&id=3bd62ad8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd62ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd62ad8')) {
      api.createRecord('3bd62ad8', component.options)
    } else {
      api.reload('3bd62ad8', component.options)
    }
    module.hot.accept("./StandardizedPhoneInput.vue?vue&type=template&id=3bd62ad8&scoped=true", function () {
      api.rerender('3bd62ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/StandardizedPhoneInput.vue"
export default component.exports